import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Header from "../Header/Header";
import { useSelector, useDispatch } from "react-redux";
import dashboardIcon from "../../icons/dashboard.svg";
import user from "../../icons/profile.svg";
import client from "../../icons/clients white.svg";
import MeetingReports from "../../icons/Meeting-Reports.svg";
import geofenceIcon from "../../icons/geofence.svg";
import Scheduled from "../../icons/Sche2.svg";
import ExpenseIcon from "../../img/expense-icon.svg";
import LockIcon from "../../img/MasterModule.svg";

import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import MeetingReport from "../../icons/schedule.svg";
import "./Sidebar.css";
import Dashboard from "../Dashboard/Dashboard";
import Routerr from "../../route/Routers";

import { useNavigate } from "react-router-dom";
import { closeSidebar, setOpen } from "../Header/HeaderSlice";
import config from "../../config/config";
import { meetingReport } from "../Dashboard/redirectSlice";
import { dynamiceForm } from "../../actions/DynamiceForm";

// const onlyOneUser = [
//   { title: "Dashboard", icon: dashboardIcon, link: "/dashboard", show: true },
//   { title: "Client", icon: client, link: "/client" },
//   { title: "Meeting Reports", icon: MeetingReports, link: "/outdoorduties", show: true },
//   { title: "Scheduled Meeting", icon: Scheduled, link: "/scheduledMeting", show: true },
//   { title: "Expense", icon: ExpenseIcon, link: "/expenseList", show: true },
//   { title: "Company Details", icon: ExpenseIcon, link: "/companyDetails", show: true }

// ];

//  let companyDetails={title: "Company Details", icon: ExpenseIcon, link: "/companyDetails"}

//  if(ShowSubMenu ==17084){
//   navMenu.push(companyDetails)
// }
const drawerWidth = 280;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(5)} + 10px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(6)} + 10px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Sidebar = () => {
  const localData = JSON.parse(localStorage.getItem("data")) || {};
  const Templatedata =
    localStorage.getItem("Templatedata") &&
    JSON.parse(localStorage.getItem("Templatedata"));
  const scheduledMeetingLabel =
    (Templatedata &&
      Templatedata.length > 0 &&
      Templatedata.find((header) => header.actualName === "Scheduled Meeting")
        ?.displayName) ||
    "Scheduled Meeting";
  const open = useSelector((state) => state.HeaderSlice.value);
  const profileName = JSON.parse(localStorage.getItem("data"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openMaster, setOpenMaster] = React.useState(false);

  const [NewClientTitle, setNewClientTitle] = React.useState("");
  //const [open, setOpen] = React.useState(false);
  // const ShowSubMenu = JSON.parse(localStorage.getItem("data")).hrmsUserId;
  // const NavMenuitems = ShowSubMenu == 59436 ? onlyOneUser : AllUser
  const AllUser = [
    { title: "Dashboard", icon: dashboardIcon, link: "/dashboard", show: true },
    {
      title: "User",
      icon: user,
      link: "/users",
      show: true,
    },
    {
      title: localData?.isClientNameChanged
        ? ((NewClientTitle !== "" ? NewClientTitle : "Client") + "")?.replace(
            /client/gi,
            localData?.changedClientFieldName || "Client",
          )
        : NewClientTitle !== ""
          ? NewClientTitle
          : "Client",
      icon: client,
      link: "/client",
      show: true,
    },
    {
      title: "Geofence",
      icon: geofenceIcon,
      link: "/geofenceList",
      show: localData?.isEnableGeofenceManagement ? true : false,
    },
    {
      title: "Meeting Reports",
      icon: MeetingReports,
      link: "/outdoorduties",
      show: true,
    },
    {
      title: scheduledMeetingLabel,
      icon: Scheduled,
      link: "/scheduledMeting",
      show: true,
    },
    { title: "Expense", icon: ExpenseIcon, link: "/expenseList", show: true },
    {
      title: "Company Details",
      icon: ExpenseIcon,
      link: "/companyDetails",
      show:
        JSON.parse(localStorage.getItem("data")).hrmsUserId === 59436
          ? true
          : false,
    },
    {
      title: "Company wise client",
      icon: ExpenseIcon,
      link: "/companywiseclient",
      show:
        JSON.parse(localStorage.getItem("data")).hrmsUserId === 59436
          ? true
          : false,
    },
    {
      title: "Master",
      icon: LockIcon,
      show: localData?.enableDefaultMeetingWithinGeofence,
      isSubMenu: true,
      children: [
        {
          title: "Vehicle Type",
          link: "/vehicleType",
          show: localData?.enableDefaultMeetingWithinGeofence,
        },
      ],
    },
    // { title: "companywiseclientstatus", icon: ExpenseIcon, link: "/companywiseclientstatus", show: JSON.parse(localStorage.getItem("data")).hrmsUserId === 59436 ? true : false },
  ];
  const currentLocation = window.location.pathname;

  function history(data) {
    if (data == "Meeting Reports") {
      window.open("/outdoorduties", "_self");
    } else if (data == "Dashboard") {
      window.open("/dashboard", "_self");
    }
  }
  const handleMouseEnter = () => {
    dispatch(setOpen());
  };

  const handleMouseLeave = () => {
    dispatch(closeSidebar());
  };

  const fetchHederTitle = () => {
    const Templatedata = JSON.parse(localStorage.getItem("Templatedata"));
    const NewClient =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "client") {
          return setNewClientTitle(val.displayName);
        }
      });
  };

  const handleOrderClick = (path) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const userData = {
      id: data.id,
      name: data.name,
      hrmsCompanyId: data.hrmsCompanyId,
      hrmsUserId: data.hrmsUserId,
      companyLogoUrl: data.companyLogoUrl,
    };
    window.open(
      `${config.baseUrlForOderManagement}${path}?userData=${window.btoa(
        JSON.stringify(userData),
      )}`,
      "_blank",
    );
  };

  React.useEffect(() => {
    fetchHederTitle();
  }, []);

  const checkMenuPermission = (menu) => {
    switch (menu.link) {
      case "/vehicleType":
        return Boolean(localData?.enableDefaultMeetingWithinGeofence);

      default:
        return Boolean(menu.show);
    }
  };

  const checkChildrenMenuAnyHavePermission = (menu) => {
    if (!menu.isSubMenu) {
      return checkMenuPermission(menu);
    }

    return menu.children?.some((child) => checkMenuPermission(child));
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        open={open}
        className="sidebar"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <DrawerHeader />

        <Divider />
        <List className="menu">
          {AllUser &&
            AllUser.map((item, index) => {
              if (item.isSubMenu && checkChildrenMenuAnyHavePermission(item)) {
                return (
                  <React.Fragment key={index}>
                    <ListItem disablePadding sx={{ display: "block" }}>
                      <ListItemButton
                        className="list__items"
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2,
                        }}
                        onClick={() => setOpenMaster(!openMaster)}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: "40px",
                            mr: open ? 0 : "auto",
                            justifyContent: open ? "start" : "center",
                          }}
                        >
                          <img src={item.icon} alt="" />
                        </ListItemIcon>

                        <ListItemText
                          primary={item.title}
                          sx={{ opacity: open ? 1 : 0 }}
                        />

                        {open ? (
                          openMaster ? (
                            <ExpandLess style={{ color: "white" }} />
                          ) : (
                            <ExpandMore style={{ color: "white" }} />
                          )
                        ) : (
                          ""
                        )}
                      </ListItemButton>
                    </ListItem>

                    <Collapse in={openMaster} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.children
                          .filter(checkMenuPermission)
                          .map((child) => (
                            <ListItem
                              key={child.link}
                              disablePadding
                              sx={{
                                display: "block",
                              }}
                              onClick={() => {
                                navigate(child.link);
                                dispatch(closeSidebar());
                              }}
                            >
                              <ListItemButton
                                className={`list__items ${
                                  child.link === currentLocation ? "active" : ""
                                }`}
                                sx={{
                                  pl: 7,
                                  minHeight: 40,
                                }}
                              >
                                <ListItemText primary={child.title} />
                              </ListItemButton>
                            </ListItem>
                          ))}
                      </List>
                    </Collapse>
                  </React.Fragment>
                );
              }
              return (
                checkChildrenMenuAnyHavePermission(item) && (
                  <ListItem
                    key={index}
                    disablePadding
                    sx={{ display: "block" }}
                    onClick={() => {
                      localStorage.removeItem("ExpencesData");
                      if (item.link == "/outdoorduties") {
                        navigate(item.link);
                        dispatch(meetingReport());
                      } else {
                        navigate(item.link);
                        dispatch(closeSidebar());
                      }
                    }}
                  >
                    {item.show === true ? (
                      <ListItemButton
                        className={`list__items ${
                          item.link === currentLocation ? "active" : ""
                        }`}
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.0,
                        }}
                      >
                        {item.show === true ? (
                          <ListItemIcon
                            sx={{
                              minWidth: "40px",
                              mr: open ? 0 : "auto",
                              justifyContent: open ? "start" : "center",
                            }}
                          >
                            {
                              <img
                                src={item.show === true ? item.icon : ""}
                                alt="icons"
                              ></img>
                            }
                          </ListItemIcon>
                        ) : (
                          ""
                        )}

                        {item.show === true ? (
                          <ListItemText
                            primary={item.show === true ? item.title : ""}
                            sx={{ opacity: open ? 1 : 0 }}
                          />
                        ) : (
                          ""
                        )}
                        {/* <span>{item.title}</span> */}
                      </ListItemButton>
                    ) : (
                      ""
                    )}
                  </ListItem>
                )
              );
            })}
          {/* order menu */}
          {getOrderMgmtPermissionRoute() && (
            <ListItem
              key="order"
              disablePadding
              sx={{ display: "block" }}
              onClick={() => handleOrderClick(getOrderMgmtPermissionRoute())}
            >
              <ListItemButton
                className={`list__items`}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.0,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: "40px",
                    mr: open ? 0 : "auto",
                    justifyContent: open ? "start" : "center",
                  }}
                >
                  {<img src={Scheduled} alt="icons"></img>}
                </ListItemIcon>
                <ListItemText
                  primary="Order Management"
                  sx={{ opacity: open ? 1 : 0 }}
                />
                {/* <span>{item.title}</span> */}
              </ListItemButton>
            </ListItem>
          )}
          {/* order menu end */}
        </List>
        <div className="versionstyle">
          <span
            style={{ fontSize: ".5rem", marginBottom: 0, marginRight: "300px" }}
          >
            Version {config.version}
          </span>
        </div>
      </Drawer>
      {/* <Box
        component="main"
        sx={{ flexGrow: 1, background: "#F4F4F4", padding: "28px 10px" }}
        className="rsp_none"
      >
      </Box> */}
    </Box>
  );
};

function getOrderMgmtPermissionRoute() {
  const userPermissions = [];
  if (
    JSON.parse(localStorage.getItem("data")).userSfaPermissionMappingDTOList
  ) {
    JSON.parse(
      localStorage.getItem("data"),
    ).userSfaPermissionMappingDTOList.forEach((item) => {
      if (item.sfaPermissionDTO.sfaPermissionName.includes("Management")) {
        userPermissions.push(item.sfaPermissionDTO.sfaPermissionName);
      }
    });
  }
  console.log(userPermissions, "permisss");
  if (userPermissions.length === 0) {
    return null;
  } else if (userPermissions.includes("Firm Management")) {
    return "firmList";
  } else if (userPermissions.includes("Category Management")) {
    return "categoryList";
  } else if (userPermissions.includes("Stock Management")) {
    return "stockList";
  } else if (userPermissions.includes("OrderManagement")) {
    return "orderList";
  } else if (userPermissions.includes("Client Management")) {
    return "clientList";
  } else if (userPermissions.includes("Ledger Management")) {
    return "ledgerList";
  } else {
    return null;
  }
}

export default Sidebar;
